<template>
   <div>
        <el-radio-group v-model="formData.type">
            <el-radio :label="1">动态项目名称</el-radio>
            <el-radio :label="2">自定义</el-radio>
        </el-radio-group>
        <p/>
        <el-input
            v-if="formData.type === 2"
            v-model="formData.describeText"
            placeholder="请输入"
            class="mt10"
            style="width:400px"
            :maxlength="maxlength"
            show-word-limit
        />
   </div>
</template>

<script>

export default {
    name: 'RadioDesc',
    props: {
        maxlength: {
            type: Number,
            default: 20,
        },
        value: {
            type: Array,
            default: ()=> [1, ''],
        },
    },
    data() {
        const [ type = 1, describeText ] = this.value;
        return {
            formData: {
                type,
                describeText
            }
        }
    },
    computed: {
        formatformData() {
            return [this.formData.type, this.formData.describeText]
        }
    },
    watch: {
        formData: {
            handler(val) {
                this.$emit('input', [...this.formatformData])
            },
            deep: true,
        },
    },
}
</script>

<style lang="scss" scoped>

</style>